import { call, put } from "redux-saga/effects";
import { requestUploadInlineImage } from "../requests/attachment";
import { showAlert } from "../../slices/alerts";
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleUploadInlineImage(action) {
    try {
        const { file, callback } = action.payload;
        const response = yield call(requestUploadInlineImage, file);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error, 'The image could not be uploaded') }));
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
    }
}
